export default {
  colors: {
    primary: '#f2910a',
  },
};
